module.exports = __webpack_public_path__ + "static/img/1000000534_red.ff982c5d.jpg";